// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__GYWW0"};